import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';

const roomData = [
  {
    id: 'single',
    nameKo: '싱글룸',
    nameEn: 'SINGLE',
    capacity: '1인',
    maxCapacity: '1인',
    rooms: '6실 보유',
    bed: '싱글 1개',
    checkIn: '15:00',
    checkOut: '12:00',
    desc: '1인 투숙에 최적화된 아늑하고 깔끔한 객실입니다.편안한 휴식을 취하실 수 있습니다.',
    imgs: [
      'https://images.trvl-media.com/lodging/12000000/11080000/11079500/11079470/7710349e.jpg?impolicy=resizecrop&rw=1200&ra=fit',
      'https://images.trvl-media.com/lodging/12000000/11080000/11079500/11079470/b15ec448.jpg?impolicy=resizecrop&rw=1200&ra=fit',
      'https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/114987105d51fa0b521c5c8bb220ea7f.png',
    ],
    fallbackImgs: [
      'https://public.readdy.ai/ai/img_res/d449a2300a1b392be50785d031dc93f7.jpg',
      'https://readdy.ai/api/search-image?query=single%20hotel%20room%20bathroom%20clean%20tiles%20modern%20fixtures%20Korean%20business%20hotel&width=750&height=500&seq=single-room-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=single%20hotel%20room%20desk%20workspace%20window%20view%20Korean%20city%20hotel%20comfortable&width=750&height=500&seq=single-room-3&orientation=landscape',
    ],
  },
  {
    id: 'double',
    nameKo: '더블룸',
    nameEn: 'DOUBLE',
    capacity: '1~2인',
    maxCapacity: '2인',
    rooms: '10실 보유',
    bed: '더블 1개',
    checkIn: '15:00',
    checkOut: '12:00',
    desc: '더블 침대 1개가 배치된 넓고 쾌적한 객실입니다. 커플 또는 비즈니스 출장객에게 적합하며 편안한 숙박 환경을 제공합니다.',
    imgs: [
      'https://images.trvl-media.com/lodging/12000000/11080000/11079500/11079470/7710349e.jpg?impolicy=resizecrop&rw=1200&ra=fit',
      'https://images.trvl-media.com/lodging/12000000/11080000/11079500/11079470/b15ec448.jpg?impolicy=resizecrop&rw=1200&ra=fit',
      'https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/63765f2a243eff5bf01fcbd791f3c1f2.png',
    ],
    fallbackImgs: [
      'https://readdy.ai/api/search-image?query=double%20bed%20hotel%20room%20elegant%20Korean%20hotel%20queen%20size%20bed%20white%20linens%20warm%20lighting%20wood%20furniture%20clean&width=750&height=500&seq=double-room-1&orientation=landscape',
      'https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/82501192634aee600e18aa343b082940.png',
      'https://readdy.ai/api/search-image?query=double%20hotel%20room%20interior%20cozy%20Korean%20city%20hotel%20comfortable%20furniture&width=750&height=500&seq=double-room-3&orientation=landscape',
    ],
  },
  {
    id: 'deluxe-double',
    nameKo: '디럭스 더블',
    nameEn: 'DELUXE DOUBLE',
    capacity: '1~2인',
    maxCapacity: '2인',
    rooms: '18실 보유',
    bed: '더블 1개',
    checkIn: '15:00',
    checkOut: '12:00',
    desc: '넓고 고급스러운 인테리어로 꾸며진 디럭스 더블 객실입니다. 더욱 쾌적하고 여유로운 공간에서 특별한 숙박을 경험하실 수 있습니다.',
    imgs: [
      'https://cf.bstatic.com/xdata/images/hotel/max1280x900/34634610.jpg?k=d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2c3d4e5&o=&hp=1',
      'https://cf.bstatic.com/xdata/images/hotel/max1280x900/34634612.jpg?k=e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2c3d4e5f6&o=&hp=1',
      'https://cf.bstatic.com/xdata/images/hotel/max1280x900/34634615.jpg?k=f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2c3d4e5f6a7&o=&hp=1',
    ],
    fallbackImgs: [
      'https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/5d123e7ef95739744914cb6f62bbdff1.png',
      'https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/2d49130a908942fa76a612c721dedf58.png',
      'https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/69f6822293a2f609d5c373c2fc7f8363.png',
    ],
  },
  {
    id: 'triple',
    nameKo: '트리플룸',
    nameEn: 'TRIPLE',
    capacity: '2~3인',
    maxCapacity: '3인',
    rooms: '18실 보유',
    bed: '싱글 3개',
    checkIn: '15:00',
    checkOut: '12:00',
    desc: '싱글 침대 3개가 배치된 넓은 트리플 객실입니다. 가족 여행이나 3인 단체 투숙에 최적화된 공간으로 넉넉한 수납공간도 갖추고 있습니다.',
    imgs: [
      'https://cf.bstatic.com/xdata/images/hotel/max1280x900/34634640.jpg?k=a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2c3d4e5f6a7b8c9d0e1f2a3b4&o=&hp=1',
      'https://cf.bstatic.com/xdata/images/hotel/max1280x900/34634642.jpg?k=b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5&o=&hp=1',
      'https://cf.bstatic.com/xdata/images/hotel/max1280x900/34634645.jpg?k=c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6&o=&hp=1',
    ],
    fallbackImgs: [
      'https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/482558e27e110c5d1b3f572c01c5d1b7.png',
      'https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/bf4d3712ce72bd6f4bc1a61f1682a4a8.png',
      'https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/46aae0dd9c88fee708c97cbdc0e7e6a9.jpeg',
    ],
  },
];

const services = [
  {
    title: '제공서비스',
    icon: 'ri-tv-2-line',
    highlight: false,
    items: ['케이블 TV 설치', '냉난방 에어컨', '냉장고', '전화기', '욕실 및 샤워실', '헤어드라이어', '110v/220v', '금고 (Safety Box)'],
  },
  {
    title: '특별 서비스 : 수맥파 차단',
    icon: 'ri-shield-star-line',
    highlight: true,
    desc: '영빈호텔에서는 한국 최초로 공인된 전자파와 수맥파를 중화시키는 특수 메달을 객실에 비치하여 숙박객들의 휴대폰과 전자제품에서 발생되는 전자파의 피해를 막아 주는 서비스를 제공하고 있습니다.',
  },
  {
    title: '편의시설 및 비품',
    icon: 'ri-hotel-bed-line',
    highlight: false,
    items: ['타올', '남성용 로션/스킨', '여성용 로션/스킨', '헤어젤', '빗', '면도기', '치약/치솔', '컵', '비누', '샴푸', '린스', '드라이기 등'],
  },
];

const bookingRooms = [
  { type: '싱글룸', person: '1인', capacity: '최대 1인', roomId: 'single' },
  { type: '더블룸', person: '1~2인', capacity: '최대 2인', roomId: 'double' },
  { type: '디럭스 더블', person: '1~2인', capacity: '최대 2인', roomId: 'deluxe-double' },
  { type: '트리플룸', person: '2~3인', capacity: '최대 3인', roomId: 'triple' },
];

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const roomsSchemaData = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: '영빈호텔 객실 안내',
  url: `${SITE_URL}/rooms`,
  description: '서울 동대문 영빈호텔의 싱글룸, 더블룸, 디럭스 더블, 트리플룸 객실 안내',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: '싱글룸 (Single Room)', url: `${SITE_URL}/rooms` },
    { '@type': 'ListItem', position: 2, name: '더블룸 (Double Room)', url: `${SITE_URL}/rooms` },
    { '@type': 'ListItem', position: 3, name: '디럭스 더블 (Deluxe Double)', url: `${SITE_URL}/rooms` },
    { '@type': 'ListItem', position: 4, name: '트리플룸 (Triple Room)', url: `${SITE_URL}/rooms` },
  ],
};

const RoomsPage = () => {
  const [activeRoom, setActiveRoom] = useState(0);
  const [activeImg, setActiveImg] = useState(0);
  const [imgErrors, setImgErrors] = useState<Record<string, boolean>>({});

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = '객실안내 | 영빈호텔 YOUNGBIN HOTEL';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', '서울 동대문 영빈호텔 객실안내. 싱글룸, 더블룸, 디럭스 더블, 트윈룸, 디럭스 트윈, 트리플룸 등 다양한 객실 타입 운영. 체크인 15:00 / 체크아웃 12:00.');
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-rooms';
    script.textContent = JSON.stringify(roomsSchemaData);
    document.head.appendChild(script);
    return () => {
      document.title = '영빈호텔 | YOUNGBIN HOTEL';
      if (metaDesc) metaDesc.setAttribute('content', '서울 중구 동대문 영빈호텔. 동대문 쇼핑상가 도보 10분, 사우나·무료와이파이·24시간 컨시어지 제공. TEL: 02-2277-1141');
      const el = document.getElementById('schema-rooms');
      if (el) el.remove();
    };
  }, []);

  const room = roomData[activeRoom];

  const handleRoomChange = (idx: number) => {
    setActiveRoom(idx);
    setActiveImg(0);
  };

  const getImgSrc = (roomId: string, imgIdx: number) => {
    const r = roomData.find((d) => d.id === roomId);
    if (!r) return '';
    const key = `${roomId}-${imgIdx}`;
    if (imgErrors[key]) {
      return r.fallbackImgs[imgIdx] || r.fallbackImgs[0];
    }
    return r.imgs[imgIdx];
  };

  const handleImgError = (roomId: string, imgIdx: number, e: React.SyntheticEvent<HTMLImageElement>) => {
    const key = `${roomId}-${imgIdx}`;
    setImgErrors((prev) => ({ ...prev, [key]: true }));
    const r = roomData.find((d) => d.id === roomId);
    if (r) {
      (e.target as HTMLImageElement).src = r.fallbackImgs[imgIdx] || r.fallbackImgs[0];
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Sub Header */}
      <div className="pt-20 bg-stone-800">
        <div className="max-w-7xl mx-auto px-6 py-10">
          <p className="text-amber-400 text-xs tracking-[0.3em] uppercase mb-2">ROOM GUIDE</p>
          <h1 className="text-3xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
            객실안내
          </h1>
        </div>
        {/* Sub Nav Tabs */}
        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex gap-0 overflow-x-auto">
              {roomData.map((r, idx) => (
                <button
                  key={r.id}
                  onClick={() => handleRoomChange(idx)}
                  className={`px-5 py-4 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer border-b-2 ${
                    activeRoom === idx
                      ? 'border-amber-400 text-amber-400'
                      : 'border-transparent text-white/60 hover:text-white hover:border-white/40'
                  }`}
                >
                  {r.nameEn}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Room Detail */}
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="flex flex-col lg:flex-row gap-12 items-start mb-20">

          {/* 이미지 */}
          <div className="w-full lg:w-3/5">
            <div className="w-full h-80 md:h-[420px] overflow-hidden rounded-xl bg-stone-100 mb-3">
              <img
                src={getImgSrc(room.id, activeImg)}
                alt={room.nameKo}
                className="w-full h-full object-cover object-top transition-all duration-500"
                onError={(e) => handleImgError(room.id, activeImg, e)}
              />
            </div>
            <div className="flex gap-2">
              {room.imgs.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveImg(idx)}
                  className={`w-24 h-16 overflow-hidden rounded-lg border-2 transition-all cursor-pointer flex-shrink-0 bg-stone-100 ${
                    activeImg === idx ? 'border-amber-600' : 'border-transparent opacity-60 hover:opacity-100'
                  }`}
                >
                  <img
                    src={getImgSrc(room.id, idx)}
                    alt=""
                    className="w-full h-full object-cover object-top"
                    onError={(e) => handleImgError(room.id, idx, e)}
                  />
                </button>
              ))}
            </div>
          </div>

          {/* 객실 정보 */}
          <div className="w-full lg:w-2/5">
            <p className="text-xs text-amber-700 tracking-widest uppercase mb-1">{room.nameEn}</p>
            <h2 className="text-2xl font-bold text-gray-900 mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
              {room.nameKo}
            </h2>
            <div className="w-10 h-0.5 bg-amber-500 mb-5" />

            {/* 기준 정보 */}
            <div className="flex flex-wrap gap-3 mb-5">
              <span className="flex items-center gap-1.5 text-xs text-gray-600 bg-stone-50 px-3 py-1.5 rounded-full">
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-user-line text-amber-600" />
                </div>
                기준 {room.capacity}
              </span>

            </div>

            <p className="text-gray-500 text-sm leading-relaxed mb-7">{room.desc}</p>

            {/* 스펙 */}
            <div className="grid grid-cols-2 gap-3 mb-7">
              {[
                { icon: 'ri-hotel-bed-line', label: '침대', value: room.bed },
                { icon: 'ri-group-line', label: '최대 정원', value: room.maxCapacity },
                { icon: 'ri-login-box-line', label: '체크인', value: room.checkIn },
                { icon: 'ri-logout-box-line', label: '체크아웃', value: room.checkOut },
              ].map((spec) => (
                <div key={spec.label} className="flex items-center gap-3 p-3 bg-stone-50 rounded-lg">
                  <div className="w-8 h-8 flex items-center justify-center bg-amber-50 rounded-full shrink-0">
                    <i className={`${spec.icon} text-amber-700 text-sm`} />
                  </div>
                  <div>
                    <p className="text-xs text-gray-400">{spec.label}</p>
                    <p className="text-sm font-semibold text-gray-800">{spec.value}</p>
                  </div>
                </div>
              ))}
              {/* 요금 문의 */}
              <div className="col-span-2 flex items-center gap-3 p-3 bg-amber-50 rounded-lg border border-amber-100">
                <div className="w-8 h-8 flex items-center justify-center bg-amber-100 rounded-full shrink-0">
                  <i className="ri-price-tag-3-line text-amber-700 text-sm" />
                </div>
                <div>
                  <p className="text-xs text-gray-400">요금</p>
                  <p className="text-sm font-semibold text-amber-700">전화 문의</p>
                </div>
              </div>
            </div>

            {/* 문의 버튼 */}
            <a
              href="tel:0222771141"
              className="flex items-center justify-center gap-2 w-full py-3.5 bg-amber-700 text-white rounded-xl text-sm font-semibold hover:bg-amber-800 transition-colors cursor-pointer whitespace-nowrap mb-3"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line" />
              </div>
              요금 문의 : 02-2277-1141
            </a>

          </div>
        </div>



        {/* 제공서비스 / 특별서비스 / 편의시설 */}
        <div className="border-t border-stone-100 pt-16">
          <div className="text-center mb-12">
            <p className="text-amber-700 text-xs tracking-[0.3em] uppercase mb-2">SERVICES &amp; AMENITIES</p>
            <h3 className="text-2xl font-bold text-gray-900" style={{ fontFamily: "'Playfair Display', serif" }}>
              객실 서비스 안내
            </h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {services.map((svc) => (
              <div
                key={svc.title}
                className={`rounded-xl p-8 ${
                  svc.highlight ? 'bg-stone-800 text-white' : 'bg-stone-50 border border-stone-100'
                }`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-full mb-4 ${
                  svc.highlight ? 'bg-amber-600' : 'bg-amber-100'
                }`}>
                  <i className={`${svc.icon} text-xl ${svc.highlight ? 'text-white' : 'text-amber-700'}`} />
                </div>
                <h4 className={`text-sm font-bold mb-3 ${svc.highlight ? 'text-amber-300' : 'text-gray-900'}`}>
                  {svc.title}
                </h4>
                <div className={`w-8 h-0.5 mb-5 ${svc.highlight ? 'bg-amber-500' : 'bg-amber-400'}`} />
                {svc.desc ? (
                  <p className={`text-sm leading-relaxed ${svc.highlight ? 'text-stone-300' : 'text-gray-600'}`}>
                    {svc.desc}
                  </p>
                ) : (
                  <div className="flex flex-wrap gap-1.5">
                    {svc.items?.map((item) => (
                      <span
                        key={item}
                        className={`text-xs px-2.5 py-1 rounded-full ${
                          svc.highlight ? 'bg-white/10 text-stone-300' : 'bg-white border border-stone-200 text-gray-600'
                        }`}
                      >
                        {item}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* 이용안내 */}
        <div className="mt-14 p-6 bg-stone-50 rounded-xl border border-stone-100">
          <p className="text-xs font-bold text-gray-700 mb-4 flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-information-line text-amber-600" />
            </div>
            이용 안내
          </p>
          <ul className="text-xs text-gray-500 space-y-2 leading-relaxed">
            <li>· 체크인 15:00 / 체크아웃 12:00</li>
            <li>· 체크아웃 시간은 오전 12:00이며, 초과 시 추가 요금이 발생할 수 있습니다.</li>
            <li>· 객실 요금은 성수기 및 특정 기간에 따라 변동될 수 있으며, 정확한 요금은 전화 문의 부탁드립니다.</li>
            <li>· 조식은 별도 제공되지 않습니다.</li>
            <li>· 반려동물 동반 입실은 불가합니다.</li>
            <li>· 예약 취소 및 환불 규정은 예약 시 안내 사항을 확인해 주세요.</li>
          </ul>
        </div>

        {/* Back */}
        <div className="mt-12 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-8 py-3 border border-stone-300 text-gray-700 rounded-full text-sm hover:bg-stone-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line" />
            </div>
            메인으로 돌아가기
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default RoomsPage;
